<template>
    <div>
        <b-table hover small responsive show-empty
            :id="slug"
            :fields="fields"
            :items="items"
            primary-key="mdhTrackingId"
            :busy="isLoading"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            @filtered="onFiltered"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc">
            <template v-slot:cell(actions)="row">
                <b-button size="sm" @click="editItem(row.item)" class="mr-1">
                edit
                </b-button>
            </template>
            <template v-slot:cell(mdhTrackingId)="data">
                <span>{{ data.item.mdhTrackingId }}</span>
                <span v-if="data.item.jobId" style="font-size:.90em;">
                    <br/> {{ data.item.jobId }}
                </span>
            </template>

            <template v-slot:cell(formattedStatus)="data">
                <span>{{ data.item.formattedStatus }}</span>
                <span v-if="data.item.delegateName" style="font-size:.90em;">
                    <br/> Delegated: {{ data.item.delegateName }}
                </span>
            </template>

            <template v-slot:cell(selectedCandidateName)="data">
                <span v-if="data.item.requestType === '10'" style="font-size:.90em;">
                    {{ data.item.employeeName }}
                </span>
                <span v-else>
                    {{ data.item.selectedCandidateName }}
                </span>
            </template>
            
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
            <template #table-caption>{{caption}}</template>

            <template v-slot:empty="scope">
                <p>No requests found.</p>
            </template>

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
                <strong>Loading, Please Wait...</strong>
            </div>  
        </b-table>
        <div class="overflow-auto">

          <b-pagination
              v-if="this.items.length > perPage"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"/>
        </div>
    </div>
</template>

<script>
import SecureLS from "secure-ls";

export default {
    components: {
    },
    props: {
        items: Array,
        slug: [String],
        caption: String,
        isLoading: Boolean,
        filter: String,
    },
    data: () => ({
      perPage: 10,
      currentPage: 1,
      totalRows: 0,

      sortBy: 'lastUpdatedDateTime',
      sortDesc: true,

        fields: [
        ],
    }),
    created() {
        this.buildFields()
        this.setSortDetails()
        this.setTotalRows(this.items.length)
    },
    computed: {
    },
    methods: {
      onFiltered(filteredItems) {
        this.setTotalRows(filteredItems.length)
        this.currentPage = 1
      },
      setTotalRows(total){
        this.totalRows = total
      },
        editItem(item) {
            let searchSortDetails = {'key': this.slug, 'settings': {'sortBy': this.sortBy, 'sortDesc': this.sortDesc}}
            this.$store.dispatch('loadSearchSortDetails', searchSortDetails)
            this.saveSearchResults(this.slug, this.items)
            this.$emit('editRequest')
            
            if(this.slug === 'payroll-queue'){
              if (item.payrollAction === 'SEP') {
                this.$router.push({ name: 'separation', params: { id: item.id } })
              } else {
                this.$router.push({ name: 'viewPayroll', params: { id: item.id, action: item.payrollAction} })
              }
            } else if (this.slug === 'hiring-manager-queue') {
              console.log('handling the special cases')
              console.log(item.requestStatusCode)
              if (item.requestStatusCode === '36' || item.requestStatusCode === '37') {
                this.$router.push({ name: 'manager-view', params: { id: item.id, o: item.requestStatusCode } })  
              } else {
                this.$router.push({ name: 'view', params: { id: item.id } })  
              }
            } else if (this.slug === 'specialist-queue') {
              console.log('handling the special cases')
              console.log(item.requestStatusCode)
              if (item.requestStatusCode === '36' || item.requestStatusCode === '37') {
                this.$router.push({ name: 'specialist-view', params: { id: item.id, o: item.requestStatusCode } })
              } else {
                this.$router.push({ name: 'view', params: { id: item.id } })
              }
            }
            else{
              this.$router.push({ name: 'view', params: { id: item.id } })
            }
        },

        buildFields() {
            this.fields.push({key: 'mdhTrackingId', sortable: true, label: 'Number'})
            this.fields.push({key: 'divisionCode', sortable: true, label: 'Division'})
            if(this.slug === 'payroll-queue' || this.slug === 'fhr-transactions-queue') {
              this.fields.push({key: 'effectiveStartDate', sortable: true, label: 'Effective Start Date'})
            }
            else{
              this.fields.push({key: 'priority', sortable: true, label: 'Priority'})
            }
            if (this.slug === 'assigned-queue') {
              this.fields.push({key: 'requestTypeDescription', sortable: true, label: 'Request Type'})
            }
            this.fields.push({key: 'formattedStatus', sortable: true, label: 'Lifecycle Status'})
            if( this.slug === 'hiring-manager-queue' || this.slug === 'submissions-queue'){
              this.fields.push({key: 'returnPreviousLifecycleComments', sortable: true, label: 'Review Action'})
            }
            if( this.slug === 'fhr-transactions-queue' || this.slug === 'assigned-queue'){
              this.fields.push({key: 'returnPreviousLifecycleAction', sortable: true, label: 'Review Action'})
            }
            
            this.fields.push({key: 'lastUpdatedDateTime', sortable: true, label: 'Last Updated Date'})

            if (this.slug === 'leave-queue') {
              this.fields.push({key: 'employeeName', sortable: true, label: 'Employee Name'})
            } else if ( this.slug === 'payroll-queue'){
              this.fields.push({key: 'selectedCandidateName', sortable: true, label: 'Employee Name'})
            } else{
              if (this.slug === 'search') {
                this.fields.push({key: 'finalClassification', sortable: true, label: 'Final Classification'})
                this.fields.push({key: 'proposedClassification', sortable: true, label: 'Proposed Classification'})
              } else {
                this.fields.push({key: 'proposedClassification', sortable: true, label: 'Classification',
                  formatter: (value, key, item) => {
                    if (item.finalClassification) {
                      return item.finalClassification
                    } else {
                      if (item.proposedClassification) {
                        return item.proposedClassification
                      } 
                    }
                    return "" 
                  }})
              }
              if (this.slug === 'search') {
                this.fields.push({key: 'selectedCandidateName', sortable: true, label: 'Final Candidate Name'})
              } else {
                this.fields.push({key: 'selectedCandidateName', sortable: true, label: 'Selected Candidate Name'})
              }
            }

          if(this.slug === 'fm-review-queue'){
              this.fields.push({key: 'submitterName', sortable: true, label: 'Requestor'})
            }

            this.fields.push({key: 'supervisorName', sortable: true, label: 'Supervisor'})
            this.fields.push({key: 'actions', label: 'Actions'})
        },
        setSortDetails(){
          if (typeof this.$store.state.searchSortDetails[this.slug] !== "undefined") {
            this.sortBy = this.$store.state.searchSortDetails[this.slug].sortBy
          }
          if(typeof this.$store.state.searchSortDetails[this.slug] !== "undefined"){
            this.sortDesc = this.$store.state.searchSortDetails[this.slug].sortDesc
          }
        },
        saveSearchResults(slug, searchResults){
          if(slug === 'search'){
            var ls = new SecureLS({ isCompression: false });
            ls.set('hrm-request-search-results', searchResults)
          }
        }
    },
    watch: {
      items: function(){
        this.setTotalRows(this.items.length)
      }

    }
}
</script>